import type { AttendanceRecord, AttendanceStatus } from '../types/api'

/** One saved attendance row as the API returns it: one row per student per session. */
export interface AttendanceRowDto {
  id: string
  academic_class_id: string
  student_id: string
  session_date: string
  schedule_slot_key?: string | null
  status: AttendanceStatus
  notes?: string | null
  is_finalized?: boolean
  created_at?: string
  updated_at?: string
}

/**
 * Group per-student rows into sessions (class + date + schedule slot). A session
 * is finalized as soon as any of its rows is, because the backend locks per row.
 */
export function groupAttendanceRows(rows: readonly AttendanceRowDto[]): AttendanceRecord[] {
  const sessions = new Map<string, AttendanceRecord>()
  for (const row of rows) {
    const slot = row.schedule_slot_key ?? ''
    const key = `${row.academic_class_id}|${row.session_date}|${slot}`
    let session = sessions.get(key)
    if (!session) {
      session = {
        id: key,
        academic_class_id: row.academic_class_id,
        session_date: row.session_date,
        schedule_slot_key: slot === '' ? null : slot,
        finalized: false,
        entries: [],
        created_at: row.created_at ?? '',
        updated_at: row.updated_at ?? '',
      }
      sessions.set(key, session)
    }
    session.entries.push({
      student_id: row.student_id,
      student_name: '',
      status: row.status,
      notes: row.notes ? row.notes : null,
    })
    if (row.is_finalized) session.finalized = true
    if (row.updated_at && row.updated_at > session.updated_at) session.updated_at = row.updated_at
  }
  return [...sessions.values()]
}
